import React from "react"
import { ThemeProvider } from "./src/utils/themeContext"

export const wrapRootElement = ({ element }) => (
  <ThemeProvider>{element}</ThemeProvider>
)

export const onRouteUpdate = () => {
  // 1. Existing Force-Display Fix
  // Ensures banner shows on Gatsby route changes if it didn't load initially
  const triggerCookiebot = () => {
    if (window.Cookiebot && !document.getElementById('CybotCookiebotDialog')) {
      window.Cookiebot.renew();
    }
  };
  setTimeout(triggerCookiebot, 500);

  // 2. The GTM Consent Bridge (Phase 2)
  if (window.Cookiebot) {
    window.addEventListener('CookiebotOnAccept', function () {
      // Create the GTM dataLayer if it doesn't exist
      window.dataLayer = window.dataLayer || [];

      // Map Cookiebot categories to Google Consent Mode V2 variables
      const consentUpdate = {
        event: 'cookie_consent_update', // Custom event for GTM triggers
        ad_storage: window.Cookiebot.consent.marketing ? 'granted' : 'denied',
        analytics_storage: window.Cookiebot.consent.statistics ? 'granted' : 'denied',
        ad_user_data: window.Cookiebot.consent.marketing ? 'granted' : 'denied',
        ad_personalization: window.Cookiebot.consent.marketing ? 'granted' : 'denied',
      };

      // Push update to GTM
      window.dataLayer.push(consentUpdate);

      // Also send the native Google Consent 'update' command
      if (window.gtag) {
        window.gtag('consent', 'update', {
          ad_storage: consentUpdate.ad_storage,
          analytics_storage: consentUpdate.analytics_storage,
          ad_user_data: consentUpdate.ad_user_data,
          ad_personalization: consentUpdate.ad_personalization,
        });
      }

      console.log("[Phase 2] GTM Consent Bridge Active:", consentUpdate);
    });
  }
};